<app-tag-filter></app-tag-filter>
<p-divider></p-divider>
<div>
  <p-pickList
    class="app-pick-list"
    [source]="sourceList()"
    [target]="targetList()"
    [dragdrop]="true"
    [responsive]="true"
    [showSourceControls]="showSourceControls"
    [showTargetControls]="showTargetControls"
    (onMoveToSource)="removeFromSelection($event)"
    (onMoveToTarget)="addToSelection($event)"
    (onMoveAllToTarget)="addToSelection($event)"
    (onMoveAllToSource)="removeFromSelection($event)"
    [sourceStyle]="{ height: '30rem' }"
    [targetStyle]="{ height: '30rem' }"
    breakpoint="1400px">
    <ng-template pTemplate="sourceHeader">
      <app-pick-list-header title="Schlagworte" [count]="sourceList().length" />
    </ng-template>
    <ng-template pTemplate="targetHeader">
      <app-pick-list-header title="Auswahl" [count]="targetList().length">
        @if (hiddenSelectionCount(); as hidden) {
          <span
            end
            pTooltip="Durch den Filter ausgeblendet, bleiben aber ausgewählt.">
            +{{ hidden }} ausgeblendet
          </span>
        }
      </app-pick-list-header>
    </ng-template>
    <ng-template let-tag pTemplate="item">
      <div class="pl-row">
        <i class="fas fa-tag pl-icon"></i>
        <span class="pl-name">{{ tag.title }}</span>
      </div>
    </ng-template>
    <ng-template pTemplate="emptymessagesource">
      <div class="pl-empty">Keine weiteren Einträge.</div>
    </ng-template>
    <ng-template pTemplate="emptyfiltermessagesource">
      <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
    </ng-template>
    <ng-template pTemplate="emptymessagetarget">
      <div class="pl-empty">
        Noch nichts ausgewählt – per Doppelklick, Pfeil oder Ziehen übernehmen.
      </div>
    </ng-template>
    <ng-template pTemplate="emptyfiltermessagetarget">
      <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
    </ng-template>
  </p-pickList>
</div>
